import React from 'react';
import merge from 'classnames';

import { RadioButton } from '@/components/generic/RadioButton';

import { Actions } from '../components/Actions';
import { AddressLine } from '../components/AddressLine';
import { Contacts } from '../components/Contacts';
import { DefaultTag } from '../components/DefaultTag';

import { Props } from './types';

import styles from './AddressRow.module.scss';

export const AddressRow = (props: Props) => {
  const { address, isSelected, selectAddress, editAddress, deleteAddress } = props;

  return (
    <div
      className={merge(styles.address_card, {
        [styles.address_card_active]: isSelected,
      })}
      key={address.title}
      onClick={() => selectAddress(address.contact)}
    >
      <div className={styles.header}>
        <div className={styles.radio_group}>
          <RadioButton
            className={merge(styles.radio_button, {
              [styles.radio_button_selected]: isSelected,
            })}
            selected={isSelected}
          />
          <div className={styles.title}>
            <div className={styles.bold}>{address.title}&nbsp;</div>
            <AddressLine address={address} />
          </div>
        </div>
        {address.isDefault && <DefaultTag isSelected={isSelected} />}
      </div>
      <div className={styles.contacts_wrapper}>
        <Contacts address={address} classes={styles} withDivider />
        <Actions
          address={address}
          deleteAddress={deleteAddress}
          editAddress={editAddress}
          isSelected={isSelected}
        />
      </div>
    </div>
  );
};
